export default __webpack_public_path__ + "static/media/rozcestnik-pn-bg.4f70cb4a.png";